import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Shield } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4 py-12">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-sm">
        <div className="px-8 pt-8">
          <Link to="/" className="inline-flex items-center gap-3 mb-8">
            <div className="h-9 w-9 bg-slate-900 flex items-center justify-center rounded-sm">
              <Shield className="h-5 w-5 text-white" />
            </div>
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">CA CCW Training</div>
          </Link>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Chivo, sans-serif" }}>
            Sign in
          </h1>
          <p className="text-sm text-slate-600 mt-2">Access your training and progress.</p>
        </div>
        <form className="px-8 pb-8 pt-6 space-y-5" onSubmit={submit}>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-slate-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Password</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-slate-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
            />
          </div>
          {err && (
            <div data-testid="login-error" className="bg-red-50 border border-red-200 text-red-800 text-sm px-3 py-2 rounded-sm">
              {err}
            </div>
          )}
          <button
            data-testid="login-submit"
            disabled={busy}
            className="w-full bg-slate-900 hover:bg-slate-800 text-white py-3 rounded-sm font-medium transition-colors disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign In"}
          </button>
          <div className="text-sm text-center text-slate-600">
            No account?{" "}
            <Link to="/register" data-testid="link-to-register" className="text-blue-700 hover:underline font-medium">
              Enroll now
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
